import React from 'react';
import { styled } from 'linaria/react';
import Image from '@jetshop/ui/Image';
import { theme } from '../../Theming/Theming';
import { scrollBar } from '../../ui/General';
import PlayIcon from '../../ui/icons/PlayIcon';
import { youtubeThumb } from './YoutubeVideo';

const Wrapper = styled('div')`
  display: flex;
  ${theme.below.md} {
    width: 100%;
    margin: 0.5rem auto 0;
    order: 2;
  }
  ${theme.above.lg} {
    padding: 2px;
    width: 18%;
    flex-direction: column;
    order: 1;
    position: absolute;
    top: 0;
    height: 100%;
    left: 0;
    ${scrollBar}
  }
`;

const ImageWrapper = styled('div')`
  width: 100%;
  cursor: pointer;
  border: 1px solid ${theme.colors.borderLight};
  transitionopacity: 0.2s;
  opacity: 0.7;
  //box-shadow: 1px 1px 3px #555;
  &.selected {
    opacity: 0.95;
    border-color: ${theme.colors.greys[3]};
  }
  &:hover {
    opacity: 0.85;
  }
  &:focus {
    outline: none;
  }
  margin: 0;
  ${theme.above.lg} {
    &:not(:last-child) {
      margin-bottom: 0.6rem;
    }
  }
  ${theme.below.md} {
    width: 80px;
    &:not(:last-child) {
      margin-right: 0.6rem;
    }
  }
`;

const VideoWrapper = styled('div')`
  position: relative;
  padding-bottom: 100%;
  overflow: hidden;
  display: block;
  video {
    position: absolute;
    width: 180%;
    height: auto;
    top: 50%;
    left: -40%;
    transform: translateY(-50%);
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    color: ${theme.colors.white};
    font-size: 2rem;
    filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.6));
  }
`;

const YoutubeThumb = ({ id }) => {
  return (
    <VideoWrapper>
      <img src={youtubeThumb(id)} alt="" loading="lazy" />
      <PlayIcon />
    </VideoWrapper>
  );
};

const Video = ({ data }) => {
  return (
    <VideoWrapper>
      <video>
        <source src={data.url + '#t=0.1'} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <PlayIcon />
    </VideoWrapper>
  );
};

const Thumbs = ({ activeSliderImage, images, selectSliderImage }) => {
  const changeImage = (curImageNum, newImageNum) => {
    if (curImageNum === newImageNum) return;
    selectSliderImage(newImageNum, true);
  };
  return (
    <Wrapper className="thumbs-wrapper">
      {images.map((image, index) => (
        <ImageWrapper
          key={index}
          className={activeSliderImage === index && 'selected'}
          onClick={e => changeImage(activeSliderImage, index)}
        >
          {image.youtube ? (
            <YoutubeThumb id={image.youtube} />
          ) : image.video ? (
            <Video data={image} />
          ) : (
            <Image src={image.url} sizes={[250]} aspect={'1:1'} crop={false} />
          )}
        </ImageWrapper>
      ))}
    </Wrapper>
  );
};

export default Thumbs;
